import React from 'react';

const ConditionsContext = React.createContext();

export default ConditionsContext;
